<template>
  <el-input-number
    :model-value="Math.floor(value)"
    :min="0"
    :max="100"
    class="cost-input"
    @change="$emit('change', $event)"
  ></el-input-number>
</template>

<script lang="ts">
export default {
  name: 'CpaInput',
  // eslint-disable-next-line vue/no-deprecated-model-definition
  model: {
    prop: 'value',
    event: 'change',
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['value'],
  emits: ['change'],
}
</script>

<style lang="scss">
.cost-input {
  width: 140px;
  font-weight: 500;

  input {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
